import Icon from 'veui/components/Icon'
import { IconShoppingCart } from 'dls-icons-vue'

Icon.register('shopping-cart', IconShoppingCart)
